<template>
  <Head title="Regulamento" />
  <Authenticated>
    <HeaderComponent :showExtras="false"/>
    <div>
      <Heading title="Regulamento" class="xl:px-[16vw] pt-24 sm:pl-6 sm:pt-28" />
      <div class="p-4 px-5 xl:px-[16vw] min-h-[70vh]">
          <div v-html="regulation.text">
          </div>
        <!-- <RegulamentoMockado /> -->
      </div>
    </div>
  </Authenticated>
</template>

<script>
import Authenticated from "@/Layouts/Authenticated.vue";
import { Head } from "@inertiajs/inertia-vue3";
import Heading from "@/Components/UI/Texts/Heading.vue";
import PagesLayout from "@/Layouts/Pages.vue";
import Wysiwyg from "@/Components/UI/Texts/Wysiwyg.vue";
import RegulamentoMockado from "@/Components/RegulamentoMockado.vue";

export default {
  components: {
    Authenticated,
    Head,
    Heading,
    PagesLayout,
    Wysiwyg,
    RegulamentoMockado
  },

  props: {
    regulation: Object,
  },
};
</script>

